module.exports = __webpack_public_path__ + "static/media/power-on.12659879.svg";